import React from 'react';
import { useHistory } from 'react-router-dom';
import './ReturnButton.css';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';

export const ReturnButton = (props) => {
  const history = useHistory();

  return (
    <div className="ReturnButton">
      <IconAndText
        img={IconLoader.icons_arrow_goback}
        hoverImg={IconLoader.icons_arrow_goback_hover}
        text={props.text}
        onClick={() => {
          props.action && props.action();
          props.route && history && history.push(props.route);
        }}
      />
    </div>
  );
};
